// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/post-reactivation-form-payload-request-schema',
  type: 'object',
  required: [],
  properties: {
    donationItem: {
      type: 'string',
    },
    message: {
      type: 'string',
    },
    contactId: {
      type: 'string',
      format: 'uuid',
    },
    'contact.IsCompany': {
      type: 'boolean',
    },
    'contact.CompanyName': {
      type: 'string',
    },
    'contact.Salutation': {
      enum: [
        0,
        1,
        2,
      ],
    },
    'contact.FirstName': {
      type: 'string',
    },
    'contact.LastName': {
      type: 'string',
    },
    'contact.DateOfBirth': {
      type: 'string',
      format: 'date-time',
    },
    'contact.EMail': {
      type: 'string',
    },
    'contact.PhoneNumber': {
      type: 'string',
    },
    'contact.MobilePhoneNumber': {
      type: 'string',
    },
    'contact.CompanyPhone': {
      type: 'string',
    },
    'contact.Street': {
      type: 'string',
    },
    'contact.HouseNumber': {
      type: 'string',
    },
    'contact.AddressLine1': {
      type: 'string',
    },
    'contact.AddressLine2': {
      type: 'string',
    },
    'contact.POBox': {
      type: 'string',
    },
    'contact.PostalCode': {
      type: 'string',
    },
    'contact.City': {
      type: 'string',
    },
    'contact.CountryIso2': {
      type: 'string',
    },
    'contact.Website': {
      type: 'string',
    },
    newsletterItems: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    characteristicItems: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    languageIso2: {
      type: 'string',
    },
    tenantKey: {
      type: 'string',
    },
  },
} as IJSONSchema;

export default schema;
